import { registerPlugin } from "@capacitor/core";

// Native side: android/app/src/main/java/app/the99/GoProWifiPlugin.java
// Web fallback: stubs that reject so non-native builds can still import this safely.
const native = registerPlugin("GoProWifi", {
  web: () => ({
    connect: async () => { throw new Error("GoProWifi: native only"); },
    disconnect: async () => ({ disconnected: true }),
    isConnected: async () => ({ connected: false, ssid: null }),
    httpGet: async () => { throw new Error("GoProWifi: native only"); },
    httpGetBase64: async () => { throw new Error("GoProWifi: native only"); },
    httpDownload: async () => { throw new Error("GoProWifi: native only"); },
    addListener: () => ({ remove: () => {} }),
    removeAllListeners: () => {},
  }),
});

export default native;
